import icProgramFocus from "@/assets/images/user/icProgramFocus.svg";
import programFocusCont1Img1 from "@/assets/images/user/programFocusCont1Img1.jpg";
import titleBgIcon from "@/assets/images/user/titleBgIcon.svg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

interface TimeTable {
    title: string;
    titleBg: string;
    subTitle?: string | React.ReactNode;
    list: { time: string; content: string | React.ReactNode; positionTop?: boolean }[];
}

const timeTable: TimeTable[] = [
    {
        title: "Opening & Keynote",
        titleBg: "bg-multi-gradient2",
        list: [
            {
                time: "10:00 ~ 10:30",
                content: <div className="flex-1 text-[16px] text-[#666] mdm:text-[18px]">참가자 등록</div>,
            },
            {
                time: "10:30 ~ 11:00",
                content: <div className="flex-1 text-[16px] text-[#666] mdm:text-[18px]">Opening</div>,
            },
            {
                time: "10:30 ~ 11:00",
                content: (
                    <div className="flex flex-col gap-[4px] items-start md:gap-[8px]">
                        <div className="flex flex-col gap-[4px] items-start md:gap-[8px] xl:flex-row xl:gap-[12px] xl:items-center">
                            <p className="text-[14px] font-['GongGothicLight'] text-white p-[5px_8px] rounded-[8px] bg-gradient-to-r from-[#E64C88] to-[#3734C3] md:text-[16px]">
                                Keynote
                            </p>
                            <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                                Azure Kubernetes <br className="md:hidden" />
                                Service (AKS) for <br className="xl:hidden" />
                                Game Development & <br className="md:hidden" />
                                Live-Ops
                            </p>
                        </div>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            Patrick Healy, Microsoft Azure <br className="md:hidden" />
                            OSS 부문 수석 PM (Principal PM)
                        </p>
                    </div>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "TRACK A",
        titleBg: "bg-[#7987B7]",
        subTitle: "게임 개발을 위한 생성형 AI와 인프라",
        list: [
            {
                time: "13:00 ~ 14:00",
                content: (
                    <div className="flex-1 flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            AI-based DevSecOps <br className="md:hidden" />
                            for Game Development
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            Manju Ramanatupura, <br className="md:hidden" />
                            김병수 Microsoft Worldwide Gaming솔루션 아키텍트
                        </p>
                    </div>
                ),
                positionTop: true,
            },
            {
                time: "14:00 ~ 15:00",
                content: (
                    <div className="flex-1 flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            GitHub Copilot & <br className="md:hidden" />
                            Actions for Game <br className="md:hidden" />
                            Development
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            Klaire Baek, GitHub Engineering <br className="md:hidden" />
                            부문 Staff Manager
                        </p>
                    </div>
                ),
                positionTop: true,
            },
            {
                time: "15:00 ~ 16:00",
                content: (
                    <div className="flex-1 flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            Blueprints of GenAI for <br className="md:hidden" />
                            Gaming : <br className="hidden md:block xl:hidden" />
                            End-to-end AI <br className="md:hidden" />
                            Workflows on AMD GPU
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            김성환 박사, AMD Sr. Director, <br className="md:hidden" />
                            Solution Architect
                        </p>
                    </div>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "TRACK B",
        titleBg: "bg-[#5F71B0]",
        subTitle: "현업 게임사의 생성형 AI 도입 사례",
        list: [
            {
                time: "13:00 ~ 14:00",
                content: (
                    <div className="flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            AI와 게임 산업: <br className="md:hidden" />
                            게임 콘텐츠의 패러다임 전환
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            오민환, SYLO Corporation <br className="md:hidden" />
                            공동대표 (CEO)
                        </p>
                    </div>
                ),
                positionTop: true,
            },
            {
                time: "14:00 ~ 15:00",
                content: (
                    <div className="flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            Zempot의 AI기반 업무효율 <br className="md:hidden" />
                            향상 사례 소개
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            조광래, Zempot CTO
                        </p>
                    </div>
                ),
                positionTop: true,
            },
            {
                time: "15:00 ~ 16:00",
                content: (
                    <div className="flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            VARCO 3D를 활용한 게임 <br className="md:hidden" />
                            제작 사례
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            강신진 박사, 홍익대학교 게임학부 <br className="md:hidden" />
                            교수 <br />
                            나규봉 팀장, NC AI 사업팀장
                        </p>
                    </div>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "TRACK C",
        titleBg: "bg-[#58648E]",
        subTitle: (
            <span>
                게임제너레이션 | <br className="md:hidden" />
                시각예술 콘텐츠의 오늘과 미래
            </span>
        ),
        list: [
            {
                time: "13:00 ~ 14:00",
                content: <div className="flex-1 text-[16px] text-[#666] mdm:text-[18px]">참가자 등록</div>,
            },
            {
                time: "14:00 ~ 16:30",
                content: (
                    <div className="flex flex-col gap-[4px] md:gap-[8px]">
                        <p className="text-[18px] font-['GongGothicMedium'] md:text-[22px]">
                            Special Session <br className="md:hidden" />
                            &#60;Cross Culture : View&#62;
                        </p>
                        <p className="text-[14px] font-['GongGothicLight'] text-[#666] md:text-[16px]">
                            김경식 - 개그맨, &#60;출발! 비디오여행&#62; 外 <br />
                            이종범 - 작가, &#60;닥터 프로스트&#62; 外 <br />
                            권태현 - 미술 큐레이터 <br />
                            이경혁 - 게임제너레이션 편집장
                        </p>
                    </div>
                ),
                positionTop: true,
            },
        ],
    },
];

const programList = [
    {
        title: (
            <span>
                GXG 2025 컨퍼런스 <br className="md:hidden" />
                NEXT PLAY <br className="xl:hidden" />
                with Microsoft Cloud & AI
            </span>
        ),
        background: "bg-program202504",
        img: icProgramFocus,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[24px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                9/19(금), 10:00 ~ 17:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                그래비티 조선 서울 판교 B1 스페이스 볼룸
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>내용</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                게임 AI 인사이트 세션부터에서 <br className="md:hidden" />
                                시각예술 전반을 관통하는 대중문화 <br className="md:hidden" />
                                토크까지 <br />
                                게임의 상상력과 기술을 넘어 <br className="md:hidden" />
                                다음 판을 여는 시간
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programFocusCont1Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                <div className="flex flex-col gap-[20px] md:gap-[40px]">
                    <p className={txtBoxClass}>프로그램</p>
                    <ul className="flex flex-col gap-[20px]">
                        {timeTable.map((content, i) => (
                            <li
                                key={`timeTable_${i}`}
                                className={`rounded-[20px]${content.subTitle ? " bg-[#F1F4F9]" : ""}`}
                            >
                                <div className="md:flex md:items-center">
                                    <div
                                        className={`flex items-center justify-center relative w-full py-[12px] rounded-[20px_20px_0_0] md:w-[300px] md:py-[17px] ${content.titleBg}`}
                                    >
                                        <img src={titleBgIcon} alt="이미지" className="absolute inset-0" />
                                        <p className="text-[20px] font-['GongGothicMedium'] text-white md:text-[24px]">
                                            {content.title}
                                        </p>
                                    </div>
                                    {content.subTitle && (
                                        <p className="text-[18px] font-['GongGothicLight'] text-[#405397] py-[8px] text-center md:flex-1 md:text-[20px] md:px-[24px] md:text-left">
                                            {content.subTitle}
                                        </p>
                                    )}
                                </div>
                                <ul className="py-[24px] bg-white flex flex-col gap-[20px] md:border md:border-[#ddd] md:rounded-[0_20px_20px_20px] md:p-[24px] md:gap-[24px] xl:p-[40px]">
                                    {content.list.map((item, j) => (
                                        <li
                                            key={`timeTable_${i}_${j}`}
                                            className={`flex font-['GongGothicLight'] ${item.positionTop ? "" : " items-center"}`}
                                        >
                                            <p className="text-[13px] w-[100px] md:w-[120px] md:text-[16px] xl:w-[240px]">
                                                {item.time}
                                            </p>
                                            {item.content}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        ),
    },
];

export default function Focus() {
    return (
        <>
            <div className="p-[48px_0_20px] xl:pt-[60px] text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px] xl:text-right">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                defaultOpenItems={[0]}
            />
            <a
                href="https://2025gxgconference.co.kr/"
                target="_blank"
                rel="noreferrer"
                className="m-[20px_auto_0] relative block w-full h-[72px] text-white text-[20px] text-center leading-[70px] font-['GongGothicMedium'] clip-path-octagon border border-black bg-black max-w-[320px]"
            >
                <span>GXG 2025 컨퍼런스 신청하기</span>
                <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                <span className="absolute left-0 bottom-0 border-[8px] border-black border-t-transparent border-r-transparent" />
                <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                <span className="absolute right-0 bottom-0 border-[8px] border-black border-t-transparent border-l-transparent" />
            </a>
        </>
    );
}
